import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../pages/DefendantList.css';

const PaymentList = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>Payments</h1>
          <p className="page-subtitle">Track all payments and transactions</p>
        </div>
        <button className="btn btn-primary">
          <FaPlus /> Record Payment
        </button>
      </div>

      <div className="card">
        <div className="card-body">
          <p className="text-center" style={{ padding: '40px' }}>
            Payment tracking feature coming soon. This will display all payment records and outstanding balances.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaymentList;
